<template>
<div>
<div v-if="item">
<h6>{{item.display_name}}</h6>
<h6>{{item.price | spaceBetweenNumber}} UZS</h6>
   <fg-input
            :type="`text`"
            :label="`Поисковый запрос`"
            v-model="query"
          ></fg-input>

              <p-button
                  class="btn-sm mr-2"
                      type="warning"
                  round
    
                  @click.native.prevent="init"
                  ><span class="ti-reload"> Найти</span> </p-button
                >

                <br/>
                <hr/>

<div v-if="inited===true">
  
    <template v-for="(i,k) in items">
    <div v-if="i.price>0" :key="k">
        [{{i.web}}]   {{i.title}} 
        <p>
           {{i.price | spaceBetweenNumber}} UZS <sup v-if="item.price > 0" class="badge-info badge">{{Math.round(percent(i.price))}} %</sup>
        </p>
        <br/>
    </div>
    </template>
</div>
<div v-else>Пожождите, мы ищем товар на сайтах...</div>


</div>
</div>
</template>

<script>
import { cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    items: [],
    item: null,
    query: '',
    inited: false,
    cardLink: "products/card"
  }),
  components: {

  },
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
    if (this.item && this.item.display_name){
      this.query = this.item.display_name;
        this.init();
    }
  },
  methods: {
    cardContent: cardContent,
    percent(price){

      return  (this.item.price/price-1)*100*-1 ;
     
      // return 0;
    },
    init(){
      this.items = [];
      this.inited = false;
      this.$loading(true);
      const options = {
          method: 'POST',
          url: `https://api.shop.ucell.uz/api/parser`,
          data:{
            search: this.query
          },
          withCredentials:false
        };
        this.$http.request(options).then( (response) => {
          this.items = response.data;
        }).catch( (error)  => {

        }).finally(() => {
          this.inited = true;
          this.$loading(false);
        });
    }
  },
};
</script>
<style>
</style>
